export enum EGroupCreateUpdateMode {
  CREATE,
  UPDATE
}
